import React from "react";
import { Switch } from "react-router-dom";
import PageTransitionAnimator from "../components/PageTransitionAnimator";
import CostumesPage from "../pages/CostumesPage";
import IllustsPage from "../pages/IllustsPage";
import MessagesPage from "../pages/MessagesPage";
import QuizPage from "../pages/QuizPage";
import TopPage from "../pages/TopPage";
import RestrictedRoute from "./RestrictedRoute";
type Props = React.ComponentProps<typeof Switch>;

export default function Routes(props: Props) {
  return (
    <Switch {...props}>
      <RestrictedRoute exact path="/">
        <PageTransitionAnimator>
          <TopPage></TopPage>
        </PageTransitionAnimator>
      </RestrictedRoute>

      <RestrictedRoute exact path="/illustrations">
        <PageTransitionAnimator>
          <IllustsPage></IllustsPage>
        </PageTransitionAnimator>
      </RestrictedRoute>

      <RestrictedRoute exact path="/messages">
        <PageTransitionAnimator>
          <MessagesPage></MessagesPage>
        </PageTransitionAnimator>
      </RestrictedRoute>

      <RestrictedRoute exact path="/costumes">
        <PageTransitionAnimator>
          <CostumesPage name="costumes"></CostumesPage>
        </PageTransitionAnimator>
      </RestrictedRoute>

      <RestrictedRoute exact path="/quizzes">
        <PageTransitionAnimator>
          <QuizPage></QuizPage>
        </PageTransitionAnimator>
      </RestrictedRoute>
    </Switch>
  );
}
